var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"myNotice"}},[_c('div',{staticClass:"topTitle"},[_vm._v("公告中心")]),_c('div',{staticClass:"myNotice"},[_c('div',{staticClass:"rightContent"},[_c('div',{staticClass:"dataWrap"},[_c('noticeList')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }